<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/8P68MYL/8P68MYL.jpg" alt=""></div>
      <div class="detail-banner-r">

        <div class="detail-banner-t2">8P68MYL 摩托车动力总成</div>
        <div class="detail-banner-desc">
          自主研发全球唯一水平对置8缸&8DCT摩托车动力总成；<br />
          8缸机往复惯性力和力矩全平衡，点火间隔小（90°），波动激励较四缸机降低30%，排量大（2000cc），性能突出，加速强劲，拖拽感强；<br />
          通过传动系统减速增扭，轮边扭矩高达2000N·m，处于世界领先水平；<br />
          变速器为全电控方式，换挡丝滑细腻，可实现“零”顿挫的驾驶体验，具有R挡功能，实现摩托车倒行，为摩托车提供一种新的移动方式。
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心参数</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">排量</div>
          <div class="detail-utils-u">2.0L</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大功率</div>
          <div class="detail-utils-u">113kW/6500rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大扭矩</div>
          <div class="detail-utils-u">190N·m/4500rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">匹配变速箱</div>
          <div class="detail-utils-u">8DCT</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国4/欧V</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心技术</div>

      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">进气VVT</div>
          <div class="detail-four-desc">
            国内摩托车发动机创新搭载进气VVT技术，1000-5000rpm提升性能（8~19N·m）
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">电子水泵</div>
          <div class="detail-four-desc">
            电子水泵可闭环调节匹配冷却液流量，快速暖机，维持黄金工作水温。可节油1%、CO₂排放减少1.5%-3%。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-2.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-box detail-bottom-bgs">
      <!-- <div class="detail-title">低油耗</div>
					<div class="detail-desc">200 g/kW.h燃油消耗率，创造省油新高度</div> -->
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">集成式起发电机</div>
          <div class="detail-updown-desc">
            集成设计减少布置空间/降重，电机起动输出扭矩40N·m，可满足最低-20℃启动。</div>
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">缸体（高压铸造）</div>
          <div class="detail-updown-desc">
            采用缸孔喷涂，缸内温度减低10°以上，摩擦功降低20%，缸孔较铁缸套减重67%，硬度提升97%。</div>
          <div class="img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/8P68MYL/8P68MYL-7.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            ISG电机减振器：创新应用双级弹簧+橡胶减振系统
          </div>
          <div class="detail-desc">
            双向减振，兼顾全部使用工况，不同工况及场景减振特性匹配，降低发动机扭矩波动和传动系统噪音。
          </div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box ">
      <div class="sw-page swiper-pagination"></div>
      <div class="detail-swiper-left">
        <div class="detail-tabs">
          <div class="detail-tab-item active">
            <div class="detail-tab-title">集成油气分离器的缸盖罩</div>
            <div class="detail-tab-desc">
              采用镁铝合金，集成油气分离结构，减轻重量，简化布置结构。</div>
          </div>
          <div class="detail-tab-item">
            <div class="detail-tab-title">轻量化曲轴</div>
            <div class="detail-tab-desc">
              十字惯性力自平衡曲轴，减小轴承负荷，抑制整机振动及噪声，曲柄臂最薄厚度仅2.5mm, 档宽15mm,采用整体氮化工艺提升强度。</div>
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              2.5mm
            </div>
            <div class="detail-swiper-d">
              曲柄臂最薄厚度
            </div>
          </div>
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              15mm
            </div>
            <div class="detail-swiper-d">
              档宽
            </div>
          </div>
        </div>
      </div>
      <div class="detail-swiper-right swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-6.jpg" alt=""></div>
          <div class="swiper-slide img-box"><img src="/assets/product/engine/8P68MYL/8P68MYL-5.jpg" alt=""></div>
        </div>
        <div class="sw-page swiper-pagination"></div>
      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,

        speed: 300,
        preventClicks: true,
        effect: 'fade',
        pagination: {
          el: container.querySelector('.sw-page'),
          clickable: true,
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const tabItems = document.querySelectorAll('.detail-tab-item');
            tabItems.forEach((item, index) => {
              if (index === activeIndex) {
                item.classList.add('active');
              } else {
                item.classList.remove('active');
              }
            });
          },
        },
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '8P68MYL 摩托车动力总成 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/8P68MYL.html'
};

import { createApp } from 'vue';
import App from './8P68MYL.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./8P68MYL.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>